import { Injectable } from '@angular/core';
import { MessageService } from '@sla-ng/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { IAddArticleRevenue } from '../../../models/add-article-revenue.model';
import { IArticleRevenue } from '../../../models/article-revenue.model';
import { ArticleResource } from '../../../resources/article-resource.service';
import { IArticleRevenueState } from './article-revenue.state.model';

let _state: IArticleRevenueState = {
    articleRevenues: [],
    isLoading: false,
};

@Injectable({
    providedIn: 'root',
})
export class ArticleRevenueFacade {
    protected store$: BehaviorSubject<IArticleRevenueState> = new BehaviorSubject<IArticleRevenueState>(_state);

    constructor(private myArticleResource: ArticleResource,
                private myMessageService: MessageService) {
    }

    public async fetchArticleRevenues(articleId: number): Promise<void> {
        this.updateState({ ..._state, isLoading: true });
        const articleRevenues: IArticleRevenue[] = await firstValueFrom(this.myArticleResource.getArticleRevenues(articleId)).catch(() => []);
        this.updateState({ ..._state, isLoading: false, articleRevenues });
    }

    public async addArticleRevenue(articleId: number, revenue: IAddArticleRevenue): Promise<IArticleRevenue> {
        this.updateState({ ..._state, isLoading: true });
        const addedRevenue: IArticleRevenue = await firstValueFrom(this.myArticleResource.addArticleRevenues(articleId, revenue)).catch(() => null);
        if (addedRevenue !== null) {
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.article-revenue.actions.added.label');
        }
        this.updateState({ ..._state, isLoading: false });
        return addedRevenue;
    }

    public async deleteArticleRevenue(articleId: number, revenueId: number): Promise<void> {
        this.updateState({ ..._state, isLoading: true });
        try {
            await firstValueFrom(this.myArticleResource.deleteArticleRevenue(articleId, revenueId));
            this.myMessageService.successTrans('app.actions.feedback.saved', 'app.page.article-revenue.actions.deleted.label');
        } catch (e) {
            console.error(e);
        }
        this.updateState({ ..._state, isLoading: false });
    }

    public subState(): Observable<IArticleRevenueState> {
        return this.store$.asObservable();
    }

    private updateState(state: IArticleRevenueState): void {
        this.store$.next(_state = state);
    }
}
